import React from "react";
import housemovement from "../../images/house_movement.webp";
import parceldelivery from "../../images/parcel_delivery.webp";

const Operation = () => {
    return (
        <div className="w-full bg-white py-20">
            <div className="max-w-6xl mx-auto px-6">

                {/* HEADER */}
                <div className="text-center mb-14">
                    <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
                        Our Services
                    </h2>
                    <p className="text-gray-500 mt-3 max-w-2xl mx-auto text-sm md:text-base">
                        Pickload offers fast, reliable delivery solutions for parcels and full relocation services,
                        built for speed, safety, and convenience.
                    </p>
                </div>

                {/* GRID */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">

                    {/* PARCEL DELIVERY */}
                    <div className="group bg-gray-50 border border-gray-200 rounded-3xl overflow-hidden shadow-sm hover:shadow-xl transition duration-300">

                        <div className="overflow-hidden">
                            <img
                                src={parceldelivery}
                                alt="parcel delivery"
                                className="w-full h-[370px] object-cover object-top group-hover:scale-105 transition duration-500"
                            />
                        </div>

                        <div className="p-6">
                            <h3 className="text-xl font-semibold text-gray-900">
                                Parcel Delivery
                            </h3>
                            <p className="text-gray-600 mt-2 text-sm leading-relaxed">
                                Send small and medium-sized packages quickly and securely with real-time tracking
                                and reliable riders across Nigeria.
                            </p>
                        </div>

                    </div>

                    {/* HOUSE MOVEMENT */}
                    <div className="group bg-gray-50 border border-gray-200 rounded-3xl overflow-hidden shadow-sm hover:shadow-xl transition duration-300">

                        <div className="overflow-hidden">
                            <img
                                src={housemovement}
                                alt="house movement"
                                className="w-full h-[370px] object-cover object-top group-hover:scale-105 transition duration-500"
                            />
                        </div>

                        <div className="p-6">
                            <h3 className="text-xl font-semibold text-gray-900">
                                House Movement
                            </h3>
                            <p className="text-gray-600 mt-2 text-sm leading-relaxed">
                                Full relocation support for homes and offices with trained logistics teams
                                and safe handling of your belongings.
                            </p>
                        </div>

                    </div>

                </div>

            </div>
        </div>
    );
};

export default Operation;